<template>
  <SideNav />


  <header>
    <div class="page-header min-vh-70">
      <video
        class="position-absolute fixed-top  h-100 z-index-0  rounded-5 px-0"
        id="video"
        playsinline="playsinline"
        autoplay="autoplay"
        muted="muted"
        loop="loop"
        poster="assets/img/back2.jpg"
        style="object-fit: cover;"
      >
        <source
          type="video/mp4"
          src="assets/img/draw.mp4"
        >
      </video> <span class="mask bg-gradient-dark opacity-3" />
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-12 my-auto fadeIn3 fadeInBottom">
            <div class="brand">
              <h2 class="text-white">
                昀揚產品沿革
              </h2>
              <h5 class="text-white text-normal">
                New updates and improvements to Cloud Raise.
              </h5>
              <!--              <button class="btn btn-white mt-4" type="button" name="button">Check more</button>-->
            </div>
          </div>
          <div class="col-lg-6 ms-auto  fadeIn1 fadeInBottom">
            <img
              src="assets/img/iphones.png"
              class="w-70 z-index-2 ms-6 d-none d-lg-block mt-3"
              loading="lazy"
            >
          </div>
        </div>
      </div>
    </div>
  </header>

  <div class="card card-body blur shadow-blur mx-3 mx-md-4 mt-n6 py-5">
    <div class="content">
      <div class="container">
        <div class="header text-center">
          <h3 class="title">
            Changelog
          </h3>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card card-timeline card-plain">
              <div class="card-body">
                <ul class="timeline">
                  <li class="timeline-inverted">
                    <div class="timeline-badge danger">
                      <i class="material-icons">card_travel</i>
                    </div>
                    <div class="timeline-panel">
                      <div class="timeline-heading">
                        <span class="badge badge-pill badge-danger">
                          BMMS Platform
                        </span>
                      </div>
                      <div class="timeline-body">
                        <p>
                          昀揚科技發表園區建築繪圖管理平台系統（BMMS Platform），
                          預計於 2024Q1 推出 TronMap v2.0 搶先版產品
                          ，
                          BMMS Platform 使用昀揚科技自製研發的「園區建築繪圖動畫引擎」，
                          結合「園區建築物管理系統」與「園區建築繪圖系統」等多項專利技術，
                          可在衛星地圖上繪製建築物件並且管理樓層、室內空間、公共空間、設備圖示、設施圖標、警示、通知、導覽內容、動態訊息等屬性內容，
                          繪圖的過程會將所有繪圖物件的衛星座標同步儲存在雲端資料庫（座標精準度達小數點 14 位），
                          主要可以應用在智慧園區、園區地圖導覽、元宇宙、AIOT設備資訊、ESG、資產管理、資安 SOC 監控管理、違規取締等服務。
                        </p>
                        <hr>
                        <p class="my-auto text-end">
                          2023年10月31日
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="timeline-badge success">
                      <i class="material-icons">extension</i>
                    </div>
                    <div class="timeline-panel">
                      <div class="timeline-heading">
                        <span class="badge badge-pill badge-success">
                          Curriculum Platform
                        </span>
                      </div>
                      <div class="timeline-body">
                        <p>
                          昀揚科技發表課程平台系統（Curriculum Platform），
                          預計於 2024Q1 推出 TronEdu v2.0 搶先版產品
                          ，Curriculum Platform 為支援小學、國中、高中五個學習階段、108課綱、全領域、全科、全版及知識架構的課程管理平台，
                          系統可透過昀揚科技的雲端資料中心更新教育部公佈每年最新版的知識架構與課綱，
                          亦可應用在專業證照、教育訓練、高普考、幼兒等需求且可客製化知識架構及課綱。
                          使用者可選購各種平台系統方案，快速部署線上考試、出卷、線上影音函授課程、電子書、學力診斷、學習診斷、智能補救、智能助理、遠距教學、電子書等雲端應用。
                        </p>
                        <hr>
                        <p class="my-auto text-end">
                          2023年10月31日
                        </p>
                      </div>
                    </div>
                  </li>
                  <li class="timeline-inverted">
                    <div class="timeline-badge info">
                      <i class="material-icons">fingerprint</i>
                    </div>
                    <div class="timeline-panel">
                      <div class="timeline-heading">
                        <span class="badge badge-pill badge-info">
                          TronSecurity Platform
                        </span>
                      </div>
                      <div class="timeline-body">
                        <p>
                          昀揚科技發表 TronSecurity Platform，
                          預計於 2024Q1 推出 TronSecurity v1.0 正式版產品，
                          TronSecurity Platform 與工研院資安整合服務平台（Security Platform as a Services , SECPAAS）及歐生全進行技術轉移合作，
                          提供您建立零信任架構（ZTA）中決策引擎「身分鑑別」的核心機制，
                          使用者可以使用 FIDO2 Key 在您的網站服務平台下進行無密碼或多因子認證（MFA），
                          建立一個安全不會被釣魚且易於管理的環境。
                        </p>
                        <hr>
                        <p class="my-auto text-end">
                          2023年06月20日
                        </p>                        
                      </div>
                      <div class="timeline-footer">
                        <!--
                        <div class="dropdown">
                          <button
                            type="button"
                            class="btn btn-round btn-info dropdown-toggle"
                            data-toggle="dropdown"
                          >
                            <i class="material-icons">build</i>
                          </button>
                          <div class="dropdown-menu">
                            <a
                              class="dropdown-item"
                              href="#"
                            >Action</a>
                            <a
                              class="dropdown-item"
                              href="#"
                            >Another action</a>
                            <a
                              class="dropdown-item"
                              href="#"
                            >Something else here</a>
                          </div>
                        </div>
                        -->
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="timeline-badge warning">
                      <i class="material-icons">flight_land</i>
                    </div>
                    <div class="timeline-panel">
                      <div class="timeline-heading">
                        <span class="badge badge-pill badge-warning">
                          CRStream Standard
                        </span>
                      </div>
                      <div class="timeline-body">
                        <p>
                          昀揚科技發表 CRStream Platform 影音串流媒體平台 與 CRstream Convert 影音轉檔工具，推出 CRStream Standard 產品，
                          Streaming Media Distribution Network（SMDN）獨家專利技術，比起傳統架構與各種現行通用架構有更加優化的穩定性及良率，大幅度節省網路成本。
                          成熟且安全的影片 DRM 加密技術，提供各種解析度、浮水印等保護機制。
                        </p>
                        <hr>
                        <p class="my-auto text-end">
                          2023年06月20日
                        </p> 
                      </div>
                    </div>
                  </li>

                  <li class="timeline-inverted">
                    <div class="timeline-badge primary">
                      <i class="material-icons">assignment</i>
                    </div>
                    <div class="timeline-panel">
                      <div class="timeline-heading">
                        <span class="badge badge-pill badge-primary">
                          TronEdu EMS Essentials Plus
                        </span>
                      </div>
                      <div class="timeline-body">
                        <p>
                          昀揚科技發表 TronEdu Exam Platform 題庫平台 與 TronEdu Exam Editor 題庫編輯器，推出 TronEdu EMS Essentials Plus 產品，
                          獨家「跨載具命題系統」專利技術，憑藉多年來各家教育集團、教育機構、地方政府、學校編輯人員、各領域教師的編輯操作使用經驗，解決現行小學、國中、高中的全科、全版編輯及全載具解析度問題。
                          採用 Microsoft Word 做為主要的編輯工具，並可同步題庫內容到雲端，大幅度的降低雲端題庫各種應用整合風險及成本，是一套成熟且具備豐富技術know-how的穩定產品。
                        </p>
                        <hr>
                        <p class="my-auto text-end">
                          2023年03月29日
                        </p> 
                      </div>
                      <div class="timeline-footer">
                        <!--
                        <div class="dropdown">
                          <button
                            type="button"
                            class="btn btn-round btn-info dropdown-toggle"
                            data-toggle="dropdown"
                          >
                            <i class="material-icons">build</i>
                          </button>
                          <div class="dropdown-menu">
                            <a
                              class="dropdown-item"
                              href="#"
                            >Action</a>
                            <a
                              class="dropdown-item"
                              href="#"
                            >Another action</a>
                            <a
                              class="dropdown-item"
                              href="#"
                            >Something else here</a>
                          </div>
                        </div>
                        -->
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <Footer />
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame } from '@/lib/oltModule/initOltVue3';
//import Header from '@/components/Header.vue';
import { SideNav , Header , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: {
    SideNav,
    //Header,
    //NavBar,
    // Settings,
    Footer,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;

    function goToPage(page){
      if(router.currentRoute.value.name == page) { return; }
      router.push(page);
    }

    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      // function
      goToPage,
      chkLogin,
    };
  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
